import { Link } from "react-router-dom";
import type { Game } from "@/mocks/games";
import { formatPlayers, getCategoryName } from "@/utils/gameUtils";
import { usePlay } from "./PlayProvider";

interface GameCardProps {
  game: Game;
}

export default function GameCard({ game }: GameCardProps) {
  const { openPlay } = usePlay();

  return (
    <div className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition duration-300 hover:-translate-y-1 hover:border-primary-200">
      <Link to={`/detail/${game.id}`} className="block" aria-label={`查看 ${game.name} 详情`}>
        <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
          <img
            src={game.cover}
            alt={`${game.name} 游戏封面`}
            title={`${game.name} 网页游戏在线试玩`}
            className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
          />
          <span className="absolute left-2 top-2 rounded-full bg-primary-500 px-2.5 py-0.5 text-[11px] font-bold text-background-50">
            {getCategoryName(game.category)}
          </span>
          <span className="absolute right-2 top-2 flex items-center gap-1 rounded-full bg-foreground-950/70 px-2 py-0.5 text-[11px] font-bold text-background-50">
            <i className="ri-star-fill text-primary-400"></i>
            {game.rating.toFixed(1)}
          </span>
        </div>
      </Link>
      <div className="p-3 md:p-4">
        <h3 className="truncate text-sm font-bold text-foreground-900 md:text-base">
          <Link to={`/detail/${game.id}`} className="transition hover:text-primary-600">
            {game.name}
          </Link>
        </h3>
        <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">{game.summary}</p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
            {game.theme}
          </span>
          {game.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-background-100 px-2 py-0.5 text-[11px] font-medium text-foreground-700"
            >
              {tag}
            </span>
          ))}
        </div>
        <div className="mt-3 flex items-center justify-between gap-2 border-t border-background-200 pt-3">
          <span className="flex items-center gap-1 whitespace-nowrap text-[11px] text-foreground-500">
            <i className="ri-fire-line text-primary-500"></i>
            {formatPlayers(game.players)}
          </span>
          <button
            type="button"
            onClick={() => openPlay(game)}
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-bold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-play-fill"></i>
            立即试玩
          </button>
        </div>
      </div>
    </div>
  );
}